import React from 'react';
import { connect } from 'react-redux';

import Row from './row';
import './main.less';

const Table = props => {
	const { table, intl }  = props;

	return (
		<div className="table-container conversions-garant-approve-requests-table">
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr>
						{
							table.headers
								.map((header, i) => <th key={i} className={header.className || ''}>{intl(header.title)}</th>)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) =>
						<Row key={i} row={row} {...props} />
					)}
				</tbody>
			</table>
		</div>
	);
};

class TableContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { activeRowId: null, editedField: null };
		this.setActiveRow = this.setActiveRow.bind(this);
	}

	setActiveRow(id, editedField) {
		this.setState({ activeRowId: id, editedField });
	}

	render() {
		return <Table {...this.props} {...this.state} setActiveRow={this.setActiveRow} />;
	}

}
export default connect(state => ({ requestTypes: state.root.lists['manual-approve-request-types'] }))(TableContainer);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-garant-approve-requests/components/table/main.js